import React from "react";
import { FaEye } from "react-icons/fa";

import {
  DEFAULT_AVATAR,
  formatDateShort,
  getAdherentCreatedDate,
  getAdherentName,
  getAdherentPhoto,
  getAgeLabel,
  getGenreStyle,
} from "../utils/adminAdherentsUtils";

function AdherentsTable({ adherents = [], onOpen }) {
  return (
    <section className="hidden overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20 lg:block">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1320px] text-left">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
              <th className="px-4 py-3">Judoka</th>
              <th className="px-4 py-3">Genre</th>
              <th className="px-4 py-3">Naissance</th>
              <th className="px-4 py-3">Poids</th>
              <th className="px-4 py-3">Club</th>
              <th className="px-4 py-3">Département</th>
              <th className="px-4 py-3">Licence</th>
              <th className="px-4 py-3">Création</th>
              <th className="px-4 py-3 text-right">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-white/10">
            {adherents.map((adherent) => (
              <tr
                key={adherent.id}
                className="text-sm transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03]"
              >
                <td className="px-4 py-3">
                  <div className="flex min-w-[220px] items-center gap-3">
                    <img
                      src={getAdherentPhoto(adherent)}
                      alt={getAdherentName(adherent)}
                      className="h-11 w-11 rounded-2xl object-cover"
                      onError={(event) => {
                        event.currentTarget.src = DEFAULT_AVATAR;
                      }}
                    />

                    <div className="min-w-0">
                      <p className="truncate font-bold text-slate-950 dark:text-white">
                        {getAdherentName(adherent)}
                      </p>

                      <p className="text-xs font-semibold text-slate-400">
                        ID #{adherent.id}
                      </p>
                    </div>
                  </div>
                </td>

                <td className="px-4 py-3">
                  <span
                    className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getGenreStyle(
                      adherent.genre,
                    )}`}
                  >
                    {adherent.genre || "Non spécifié"}
                  </span>
                </td>

                <td className="px-4 py-3">
                  <p className="font-semibold text-slate-600 dark:text-white/60">
                    {formatDateShort(adherent.date_naissance)}
                  </p>
                  <p className="text-xs font-semibold text-slate-400">
                    {getAgeLabel(adherent.date_naissance)}
                  </p>
                </td>

                <td className="whitespace-nowrap px-4 py-3 font-semibold text-slate-600 dark:text-white/60">
                  {adherent.poids ? `${adherent.poids} kg` : "—"}
                </td>

                <td className="px-4 py-3">
                  <p className="max-w-[260px] truncate font-semibold text-slate-600 dark:text-white/60">
                    {adherent.club || "Non renseigné"}
                  </p>
                </td>

                <td className="px-4 py-3 font-semibold text-slate-600 dark:text-white/60">
                  {adherent.departement || "—"}
                </td>

                <td className="px-4 py-3">
                  {adherent.licence_number ? (
                    <span className="inline-flex min-h-8 items-center rounded-2xl bg-emerald-100 px-3 text-xs font-bold text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200">
                      {adherent.licence_number}
                    </span>
                  ) : (
                    <span className="text-xs font-bold text-slate-400">
                      Non renseignée
                    </span>
                  )}
                </td>

                <td className="whitespace-nowrap px-4 py-3 font-semibold text-slate-500 dark:text-white/50">
                  {formatDateShort(getAdherentCreatedDate(adherent))}
                </td>

                <td className="px-4 py-3 text-right">
                  <button
                    type="button"
                    onClick={() => onOpen(adherent)}
                    className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
                  >
                    <FaEye />
                    Détails
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default AdherentsTable;